<template>
    <div class="share-button" @click="shareData">
        <Icon>
            <IconExport />
        </Icon>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import IconExport from '@/components/icons/IconExport.vue'

export default {
    components: {
        Icon,
        IconExport
    },
    methods: {
        shareData() {
            // TODO
        }
    }
}
</script>

<style lang="scss">
.share-button {
    cursor: pointer;
}
</style>